import React from 'react';
import { Card, CardContent } from '@mui/material';

import { DetailSection, Functions } from './components';
import { SDC } from './scheduleCard.classes';

export const ScheduleCard: React.FC = () => {
    return (
        <Card
            className={SDC.card}
            sx={{
                borderRadius: '12px',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                overflow: 'hidden',
                padding: '16px',
                maxWidth: '400px',
                margin: 'auto',
                background: 'linear-gradient(135deg, #ffffff, #f7f7f7)',
            }}
        >
            <CardContent
                className={SDC.content}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                }}
            >
                <DetailSection />
                <Functions />
            </CardContent>
        </Card>
    );
};
